/** Field config captured from MyADC Add Client v2 (edit_client_form). */

export const SEX_OPTIONS = ['Male', 'Female'] as const

export const STATUS_OPTIONS = [
  'Approved',
  'Visitor',
  'Discharged',
  'Hold',
  'Potential',
] as const

export const MARITAL_OPTIONS = [
  'Married',
  'Single',
  'Widowed',
  'Divorced',
  'Separated',
] as const

export const RACE_OPTIONS = [
  'Not Applicable',
  'American',
  'American Indian',
  'American/African American',
  'Alaska Native',
  'Asian',
  'Asian or Pacific Islander',
  'Black / African American',
  'Hispanic / Latino',
  'Native Hawaiian / Pacific Islander',
  'White',
  'Caucasion',
] as const

export const ETHNICITY_OPTIONS = [
  'Non Hispanic / Latino',
  'Hispanic / Latino',
] as const

export const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS',
  'KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY',
  'NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV',
  'WI','WY','DC',
] as const

export const WEEKDAYS = ['MO', 'TU', 'WED', 'THU', 'FRI', 'SAT'] as const

export const WEEKDAY_LABELS: Record<string, string> = {
  MO: 'Mon',
  TU: 'Tue',
  WED: 'Wed',
  THU: 'Thu',
  FRI: 'Fri',
  SAT: 'Sat',
  SUN: 'Sun',
}

export const SHIFT_OPTIONS = [
  { value: '', label: 'Select Shift' },
  { value: '0', label: 'Unassigned' },
  { value: '1', label: 'Shift 1' },
  { value: '2', label: 'Shift 2' },
  { value: '3', label: 'RPM' },
] as const

export const CODE_STATUS_OPTIONS = [
  'DNR',
  'DNH',
  'DNI',
  'Out of Hospital DNR Attached',
  'Full Code',
  'Comfort One',
  'Advance Directive',
  'POLST Do not resuscitate (DNR)',
  'N/A',
] as const

export const WAIVER_OPTIONS = [
  'GO',
  'CCW',
  'CRPD',
  'AACAP',
  'TBI',
  'EDWP',
  'CHC',
  'OBRA',
  'AW',
  'CLTC',
  'DDSN',
  'CO',
] as const

export const ROUTE_OPTIONS = [
  { value: '', label: 'Select Routes' },
  { value: '0', label: 'Unassigned Route' },
  { value: '935', label: 'South Route' },
  { value: '934', label: 'East Route' },
  { value: '933', label: 'North Route' },
] as const

export const DRIVER_OPTIONS = [
  { value: '', label: 'Select Driver' },
  { value: '2799', label: 'Jenny Howard' },
] as const

export const MEAL_OPTIONS = [
  { value: 'B', label: 'B (Breakfast)' },
  { value: 'A', label: 'A (AM Snack)' },
  { value: 'L', label: 'L (Lunch)' },
  { value: 'P', label: 'P (PM Snack)' },
  { value: 'S', label: 'S (Supper)' },
  { value: 'D', label: 'D (Dinner)' },
] as const

export const FOOD_PROGRAM_TYPE_OPTIONS = ['Free', 'Reduced', 'Paid'] as const

export const ET_SETTING_OPTIONS = ['Default Time', 'Time Range'] as const

export const SIGNATURE_FONT_OPTIONS = [
  { value: '', label: 'All (Signature Fonts)' },
  { value: 'Autograf', label: 'Autograf' },
  { value: 'CalendaryHands', label: 'CalendaryHands' },
  { value: 'MrDeHaviland-Regular', label: 'MrDeHaviland-Regular' },
  { value: 'Pacifico-Regular', label: 'Pacifico-Regular' },
  { value: 'Signerica_Medium', label: 'Signerica_Medium' },
  { value: 'Windsong', label: 'Windsong' },
] as const

export const DISCHARGE_NOTE_OPTIONS = [
  'Nursing Home',
  'Died',
  'Home',
  'Relocated',
  'Denied',
  'Lack of Attendance',
  'Transferred to another center',
  'Does not meet financial arrangements',
  'Other',
] as const
